import {AfterViewInit, Component, ViewChildren} from '@angular/core';

import {EditModalService} from '../../services/edit-modal.service';
import {ModalDialogV3} from '../../../../shared-modal-dynamic/models/modal-dialog-v3';

@Component({
  selector: 'app-file-size-attention-modal',
  templateUrl: './file-size-attention-modal.component.html',
  styleUrls: ['./file-size-attention-modal.component.scss']
})
export class FileSizeAttentionModalComponent extends ModalDialogV3 implements AfterViewInit {

    @ViewChildren('focusedButton') fb;

    constructor(public editModalService: EditModalService) {
        super();
    }

    onCancelBtnClicked() {
        super.close();
    }

    onConfirmBtnClicked() {
        this.announceModelChanged( {dialogConfirmed: true});
        super.close();
    }

    ngAfterViewInit(): void {
        this.fb.first.nativeElement.focus();
    }
}
